import axios from 'axios';
import router from '@/router';
import { utilityService } from '@/services/utilityService.js';
import { authTokenService } from '@/services/authTokenService.js';

export const authService = {
    login,
		logout,
		resetPassword,
		changePassword,
		forgotPassword,
    isAuthenticated,
	register,
	emailSelectedOffices
};

/**
 * Logs the user in.
 * @param {string} userName
 * @param {*} password
 * @returns the promise
 */
function login (userName, password) {
    // Clear any access_token values that may be floating around in local storage
    authTokenService.clearToken();

    return axios.post(utilityService.getApiUrl('user/authenticate'),
            // Second parameter is the data/body
            { UserName: userName, Password: password },
            // Third parameter is the configuration object
            {
                headers: utilityService.getHeaders()
            }
        )
        .then(function (response) {
			authTokenService.saveToken(response.data.token, userName);

        })
        .catch(function (e) {
            if (!e.response) {
				// network error
				this.errorStatus = 'Error: Network Error';
			} else {
				this.errorStatus = e.response.data.message;
			}
			console.log("Error " + e.response.data.message);
            throw e;
        }
    );
}

function changePassword (userName, oldPassword, newPassword, confirmPassword) {
	// Clear any access_token values that may be floating around in local storage
	return axios.put(utilityService.getApiUrl('user/password'),
					// Second parameter is the data/body
					{ UserId: userName, OldPassword: oldPassword, NewPassword: newPassword, ConfirmPassword: confirmPassword },
					// Third parameter is the configuration object
					{
							headers: utilityService.getHeaders()
					}
			)
			.then(function (response) {
			})
			.catch(function (e) {
					console.error(e);
					throw e;
			}
	);
}

function resetPassword (newPassword, confirmPassword) {
	// Clear any access_token values that may be floating around in local storage
	return axios.put(utilityService.getApiUrl('user/resetpassword'),
					// Second parameter is the data/body
					{ NewPassword: newPassword, ConfirmPassword: confirmPassword },
					{
						headers: utilityService.getHeaders()
					}
			)
			.then(function (response) {
			})
			.catch(function (e) {
					console.error(e);
					throw e;
			}
	);
}

function forgotPassword (userNameOrEmail) {
	debugger;
	// Clear any access_token values that may be floating around in local storage
	return axios.post(utilityService.getApiUrl('user/forgotpassword/'),
					// Second parameter is the data/body
					{ UserNameOrEmail: userNameOrEmail },
					// Third parameter is the configuration object
					{
							headers: utilityService.getHeaders()
					}
			)
			.then(function (response) {
			})
			.catch(function (e) {
					console.error(e);
					throw e;
			}
	);
}

function emailSelectedOffices(userNameOrEmail, userName, volume) {
	debugger;
	// Clear any access_token values that may be floating around in local storage
	return axios.post(utilityService.getApiUrl('user/emailSelectedOffices/'),{ UserNameOrEmail: userNameOrEmail, UserName: userName, Volume: volume },
					// Third parameter is the configuration object
					{
							headers: utilityService.getHeaders()
					}
			)
			.then(function (response) {
			})
			.catch(function (e) {
					console.error(e);
					throw e;
			}
	);
}

function register (username, email, password, confirmpassword) {
	return axios.post(utilityService.getApiUrl('user/register'),
		{
			UserName: username, Email: email, Password: password, ConfirmPassword: confirmpassword
		},
		{
			headers: utilityService.getHeaders()
		}
	)
	.then(function (response) {
	})
	.catch(function (e) {
		console.error(e);
		throw e;
	}
);
}
function logout () {
    authTokenService.clearToken();
    router.push('login');
}
function isAuthenticated () {
    return authTokenService.getToken() != null;
}
